import React from 'react';

const Sidebar = () => {
  return (
    <div style={styles.sidebar}>
      <h2 style={styles.title}>Resources</h2>
      <ul style={styles.menuList}>
        <li>
          <a href="https://dev.to/gallau" style={styles.link} target="_blank" rel="noopener noreferrer">Dev.to Profile</a>
        </li>
        <li>
          <a href="https://medium.com/@gallau" style={styles.link} target="_blank" rel="noopener noreferrer">Medium Blog</a>
        </li>
        <li>
          <a href="https://github.com/gallau" style={styles.link} target="_blank" rel="noopener noreferrer">GitHub</a>
        </li>
        <li>
          <a href="https://linkedin.com/in/gallau" style={styles.link} target="_blank" rel="noopener noreferrer">LinkedIn</a>
        </li>
      </ul>
    </div>
  );
};

const styles = {
  sidebar: {
    width: '200px',
    padding: '10px',
    backgroundColor: '#f4f4f4',
  },
  title: {
    fontSize: '24px',
    marginBottom: '10px',
  },
  menuList: {
    listStyleType: 'none',
    padding: 0,
  },
  link: {
    textDecoration: 'none',
    color: '#333',
    display: 'block',
    padding: '5px 0',
  },
};

export default Sidebar;